import React from 'react';
import IconButton from './CustomIconButton';


/**
 * EntryCard
 * ------------------------------------------------------------------
 * A single saved role/project row: a bold title, a muted meta line
 * built from dot-separated fragments, and edit/delete icon actions.
 * Reused on the "add project" steps and the final review screen.
 *
 * @param {string} title - e.g. "Urban Art Installation"
 * @param {string[]} meta - fragments joined with " • ", e.g. ["Berlin", "Visual Arts, Music"]
 * @param {function} onEdit
 * @param {function} onDelete
 * @param {string} editIconSrc
 * @param {string} deleteIconSrc
 */
const EntryCard = ({
  title,
  meta = [],
  onEdit,
  onDelete,
  editIconSrc,
  deleteIconSrc,
  isLoadingDelete = false,
}) => {
  return (
    <div className="amok-entry-card">
      <div className="amok-entry-card__content">
        <p className="amok-entry-card__title">{title}</p>
        {meta.length > 0 && (
          <p className="amok-entry-card__meta">
            {meta.map((fragment, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="amok-entry-card__dot"> • </span>}
                {fragment}
              </React.Fragment>
            ))}
          </p>
        )}
      </div>
      <div className="amok-entry-card__actions">
        <IconButton iconSrc={editIconSrc} label={`Edit ${title}`} tone="default" onClick={onEdit} />
        <IconButton iconSrc={deleteIconSrc} label={`Delete ${title}`} tone="danger" onClick={onDelete} loading={isLoadingDelete} />
      </div>
    </div>
  );
};

export default EntryCard;